import { Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { GlobalService } from '../../services/global.service';
import { CustomerClass, UserMyManagersClass } from '../../models/customer-class';
import { ImageService } from '../../services/image.service';
import { AlertsService } from '../../services/alerts.service';
import { ClientareaService } from '../../services/clientarea.service';
import { CustomerService } from '../../services/customer.service';
import { UploadService } from '../../services/upload.service';
import { BaseService } from '../../services/base.service';
import { AccessService } from '../../services/access.service';
import { ActiveadminComponent } from '../activeadmin/activeadmin.component';
import { ConvertImageToUrlPipe } from '../../pipes/convert-image-to-url.pipe';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';

import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { MatBadgeModule } from '@angular/material/badge';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-fullmenu',
  standalone: true,
  templateUrl: './fullmenu.component.html',
  styleUrls: ['./fullmenu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    ActiveadminComponent,
    MatDialogModule,
    MatToolbarModule,
    TranslateModule,
    MatBadgeModule,
    LanguageSelectorComponent,
    ConvertImageToUrlPipe,
    UserAvatarComponent,

    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatTooltipModule,
  ],
})
export class FullmenuComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  // @ViewChild('options') public options: MatDrawer;
  useMyManagersClass: UserMyManagersClass[];
  isHome = false;
  showCRM = false;
  showCRMMediador = false;

  // public showSidenav = false;
  public showInfoContent = false;
  public toggleSearchBar = false;
  public menus = ['vertical', 'horizontal'];
  public menuOption: string;
  public menuTypes = ['default', 'compact', 'mini'];
  public menuTypeOption: string;

  // tslint:disable-next-line:align

  constructor(
    public globalService: GlobalService,
    public authService: AuthService,
    public dialog: MatDialog,
    public router: Router,
    public imageService: ImageService,
    public alertsService: AlertsService,
    public clientareaService: ClientareaService,
    private customerService: CustomerService,
    private uploadService: UploadService,
    private baseService: BaseService,
    private accessService: AccessService,
    private cdr: ChangeDetectorRef,
  ) {
    this.globalService.showPedidoCotacao = false;
    this.isHome = this.router.url === '/' || this.router.url.startsWith('/home');
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.isHome = e.urlAfterRedirects === '/' || e.urlAfterRedirects.startsWith('/home');
        this.checkCrmAccess();
      }
    });
  }

  private lastCheckedUserId: number | null = null;
  private lastCheckedUserToken: string | null = null;

  async ngOnInit(): Promise<void> {
    this.globalService.profilePhotoLoaded$.pipe(takeUntil(this.destroy$)).subscribe(loaded => {
      if (loaded) {
        this.cdr.detectChanges();
      }
    });
    this.globalService.loginSuccess$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.checkCrmAccess(true);
    });
    this.globalService.isRestoringSession$.pipe(takeUntil(this.destroy$)).subscribe(isRestoring => {
      if (!isRestoring) {
        this.checkCrmAccess(true);
      }
    });
    await this.checkCrmAccess(true);
  }

  async checkCrmAccess(force = false): Promise<void> {
    try {
      const user = this.globalService.loggedUserClass;
      const currentUserId = user?.idUser ?? null;
      const currentToken = user?.Token ?? null;

      if (!this.authService.isLoggedin(user)) {
        this.showCRM = false;
        this.showCRMMediador = false;
        this.lastCheckedUserId = null;
        this.lastCheckedUserToken = null;
        this.cdr.detectChanges();
        return;
      }

      if (!force && currentUserId === this.lastCheckedUserId && currentToken === this.lastCheckedUserToken) {
        return;
      }
      this.lastCheckedUserId = currentUserId;
      this.lastCheckedUserToken = currentToken;

      // Verificar acesso ao CRM ADM (Apenas Admin ou quem tem a permissão 'CRM > Aceder ao CRM')
      if (user?.Admin) {
        this.showCRM = true;
      } else {
        this.showCRM = await this.accessService.GetUsersAccessValidate('CRM', 'Aceder ao CRM');
      }

      // Verificar acesso ao CRM Mediador (Apenas Admin ou quem tem a permissão 'CRM Mediador > Aceder ao CRM Mediador')
      if (user?.Admin) {
        this.showCRMMediador = true;
      } else {
        this.showCRMMediador = await this.accessService.GetUsersAccessValidate(
          'CRM Mediador',
          'Aceder ao CRM Mediador',
        );
      }
      this.cdr.detectChanges();
    } catch (e) {
      console.warn('[FullMenu] Erro ao verificar acessos CRM:', e);
    }
  }

  toggleUserMenu() {
    if (this.authService.isLoggedin(this.globalService.loggedUserClass)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });

      const nif = this.globalService.loggedUserClass?.customerClass?.NIF || this.globalService.loggedUserClass?.NIF;
      if (nif) {
        this.customerService
          .ClientAreaGetCustomerNIF(nif)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (customer: any) => {
              if (!this.globalService.loggedUserClass) return;
              const customerData = Array.isArray(customer) ? customer[0] : customer;
              if (customerData) {
                if (!this.globalService.loggedUserClass.customerClass) {
                  this.globalService.loggedUserClass.customerClass = new CustomerClass();
                }
                // Guardar foto antes da sobreposição (a API não devolve o blob Photo)
                const previousPhoto = this.globalService.loggedUserClass.customerClass.Photo;
                const previousPhotoPath = this.globalService.loggedUserClass.customerClass.PhotoPath;
                Object.assign(this.globalService.loggedUserClass.customerClass, customerData);
                // Restaurar foto se o path não mudou e a API não trouxe blob
                if (previousPhoto && !this.globalService.loggedUserClass.customerClass.Photo) {
                  if (
                    !this.globalService.loggedUserClass.customerClass.PhotoPath ||
                    this.globalService.loggedUserClass.customerClass.PhotoPath === previousPhotoPath
                  ) {
                    this.globalService.loggedUserClass.customerClass.Photo = previousPhoto;
                  }
                }
                this.globalService.loggedUserClass.customerClass.parseDates();
              }
            },
            error: error => console.log(error),
            complete: async () => {
              if (!this.globalService.loggedUserClass?.customerClass) return;
              if (this.globalService.loggedUserClass?.customerClass?.PhotoPath) {
                if (this.globalService.loggedUserClass.customerClass?.PhotoPath?.trim() !== '') {
                  this.uploadService
                    .download(this.globalService.loggedUserClass.customerClass.PhotoPath)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe({
                      next: async (file: File) => {
                        if (file && this.globalService.loggedUserClass?.customerClass) {
                          this.globalService.loggedUserClass.customerClass.Photo =
                            await this.imageService.FileToBuffer(file);
                          this.globalService.profilePhotoLoaded$.next(true);
                          this.cdr.detectChanges(); // Garante atualização visual
                        }
                      },
                    });
                }
              }

              this.useMyManagersClass = JSON.parse(
                JSON.stringify(this.globalService.loggedUserClass?.customerClass?.MyManager || '[]'),
              );
              this.baseService.onChangeName(
                this.globalService.loggedUserClass?.customerClass?.Name || '',
                this.globalService.loggedUserClass?.customerClass?.NIF || '',
              );
              if (this.globalService.loggedUserClass?.customerClass?.idCustomer) {
                this.clientareaService.ClientAreaGetCustomerShipToAddress(
                  this.globalService.loggedUserClass.customerClass.idCustomer,
                );
              }
            },
          });
      }
      // this.options.toggle();
    }
  }

  // Getters para refatoração de template (Linting performance)
  get isUserLoggedIn(): boolean {
    return this.authService.isLoggedin(this.globalService.loggedUserClass);
  }

  get userDefaultImage(): string {
    const customer = this.globalService.loggedUserClass?.customerClass;
    if (!customer) return '';
    return this.imageService.criarImagemClienteDefault('#dcdcdc', customer.Name, '#fff', 56);
  }

  get userPhoto(): string {
    return this.globalService.loggedUserClass?.customerClass?.Photo || '';
  }

  get userAlertsCount(): number {
    return this.globalService.loggedUserClass?.customerClass?.alertUser?.length || 0;
  }

  openFullMenu() {
    // this.scrollToTop();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.globalService.FullMenu = !this.globalService.FullMenu;
  }

  public scrollToTop(behavior: ScrollBehavior = 'smooth') {
    this.baseService.scrollToTop(behavior);
  }

  onLinkClick() {
    this.globalService.FullMenu = false;
    // scrollToTop removido — o Router já tem scrollPositionRestoration: 'top'
    // O scroll manual causava o efeito visual de "bounce back" ao fazer scroll up
    // no ecrã atual antes da transição para a nova rota.
  }

  ngOnDestroy() {
    if (!this.destroy$.closed) {
      this.destroy$.next();

      this.destroy$.complete();
    }
  }
}
